import { useIntl } from 'react-intl';
import messages from './messages';

export const useLocaleMessages = () => {
  const intl = useIntl();

  return (
    messages[intl.locale] ??
    messages[intl.locale.split('-')[0]] ??
    messages.en
  );
};
